import { render, staticRenderFns } from "./EditTeam.vue?vue&type=template&id=60b81a0a&scoped=true&"
import script from "./EditTeam.vue?vue&type=script&lang=js&"
export * from "./EditTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b81a0a",
  null
  
)

export default component.exports